import { authActionTypes } from "./auth.types"

const initialState = {
    currentUser: null,
    lastActiveWorkspaceId: null,
    error: null,
    isLoading: false,
    sessionStatus: null,
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        // SIGN UP: EMAIL
        case authActionTypes.SIGN_UP_EMAIL_START:
            return {
                ...state,
                loading: true,
            }
        case authActionTypes.SIGN_UP_SUCCESS:
            return {
                ...state,
                currentUser: action.payload.user,
                // notVerifiedEmail: action.payload.notVerifiedEmail,
                loading: false,
                error: null,
                sessionStatus: 'not_authorized',
            }
        case authActionTypes.SIGN_UP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                sessionStatus: 'not_authorized',
            }

        // SIGN IN: EMAIL / GOOGLE / GITHUB
        case authActionTypes.SIGN_IN_EMAIL_START:
        case authActionTypes.SIGN_IN_GOOGLE_START:
        case authActionTypes.SIGN_IN_GITHUB_START:
            return {
                ...state,
                loading: true,
            }
        case authActionTypes.SIGN_IN_SUCCESS:
            return {
                ...state,
                currentUser: action.payload.user,
                lastActiveWorkspaceId: action.payload.lastActiveWorkspaceId ?? null,
                loading: false,
                error: null,
                sessionStatus: 'authorized',
            }
        case authActionTypes.SIGN_IN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                sessionStatus: 'not_authorized',
            }

        // SIGN OUT
        case authActionTypes.SIGN_OUT_START:
            return {
                ...state,
                loading: true,
            }
        case authActionTypes.SIGN_OUT_SUCCESS:
            return {
                ...state,
                currentUser: null,
                lastActiveWorkspaceId: null,
                loading: false,
                error: null,
                sessionStatus: 'not_authorized',
            }
        case authActionTypes.SIGN_OUT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                sessionStatus: 'not_authorized',
            }
        // SIGN IN: ERRORS
        case authActionTypes.CLEAR_AUTH_ERRORS:
            return {
                ...state,
                error: null,
            }
        // SESSION
        case authActionTypes.UPDATE_SESSION_STATUS:
            return {
                ...state,
                sessionStatus: action.payload,
            }


        // FORGOT PASSWORD: START
        case authActionTypes.FORGOT_PASSWORD_START:
            return {
                ...state,
                loading: true,
            }
        // FORGOT PASSWORD: SUCCESS
        case authActionTypes.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                statusForgotPassword: true,
            }
        // FORGOT PASSWORD: FAILURE
        case authActionTypes.FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                statusForgotPassword: false,
            }

        // RESET PASSWORD: START
        case authActionTypes.RESET_PASSWORD_START:
            return {
                ...state,
                loading: true,
            }
        // RESET PASSWORD: SUCCESS
        case authActionTypes.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                statusResetPassword: true,
            }
        // RESET PASSWORD: FAILURE
        case authActionTypes.RESET_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                statusResetPassword: false,
            }

        // UPDATE USER
        case authActionTypes.UPDATE_USER_START:
            return { ...state, loading: true }
        case authActionTypes.UPDATE_USER_SUCCESS:
            return { ...state, currentUser: { ...state.currentUser, ...action.payload }, loading: false, error: null }
        case authActionTypes.UPDATE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload }

        // DELETE USER
        case authActionTypes.DELETE_USER_START:
            return { ...state, loading: true }
        case authActionTypes.DELETE_USER_SUCCESS:
            return { ...state, currentUser: null, lastActiveWorkspaceId: null, loading: false, error: null, sessionStatus: 'not_authorized' }
        case authActionTypes.DELETE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload }

        default:
            return state
    }
}

export default authReducer;
